import { Component, OnInit } from "@angular/core";
import { locale as italian } from "../../../i18n/it";
import { AuthenticationService } from "../../../auth/service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UtilsService } from "../../../auth/service/utils.service";
import moment from "moment";
import { Router } from "@angular/router";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { CostService } from "app/modules/cost/cost.service";

@Component({
  selector: "app-options",
  templateUrl: "./configurations.component.html",
  styleUrls: ["./configurations.component.scss"],
})
export class ConfigurationsComponent implements OnInit {
  public contentHeader: IContentHeader;
  public weekSetup = [];
  public daysUnlockReport: number = 3;
  public marginRequest: number = 1;
  public marginCommissionProfit: number = 1;
  public marginCommissionCost: number = 1;
  public jobPosition: any = {
    opening_description: null,
    closure_description: null,
  };
  public evidenceCost: number = 0;
  public costsList: any[] = [];
  public retroActiveDate: boolean = false;
  constructor(
    public _authService: AuthenticationService,
    public _modalService: NgbModal,
    public _utilsService: UtilsService,
    public _router: Router,
    private _costService: CostService,
  ) {
    this._utilsService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: italian.data.CONFIGURATIONS.CONFIGURATIONS,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.CONFIGURATIONS.CONFIGURATIONS,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    if (!this._authService.hasCapability("show_menu_configuration")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.daysUnlockReport = this._utilsService.themeConfiguration.days_unlock_report;
    for (let i = 0; i < 7; i++) {
      //Creo un array fatto con i giorni della settimana
      this.weekSetup.push({ name: moment().day(i).format("dddd"), isWorkDay: false });
    }
    //Modifico l'Array weekSetup con i dati salvati in backEnd
    this._utilsService.themeConfiguration.working_days.map((item: number) => {
      this.weekSetup[item].isWorkDay = true;
    });
    this.costsList = await this._costService.getStructureCostList(moment().month() + 1, moment().year());
    this.marginRequest = this._utilsService.themeConfiguration.request_margin;
    this.marginCommissionProfit = this._utilsService.themeConfiguration.commission_percentage_profit;
    this.marginCommissionCost = this._utilsService.themeConfiguration.commission_percentage_cost;
    if (!!this._utilsService.themeConfiguration && this._utilsService.themeConfiguration.description_text && !!this._utilsService.themeConfiguration.description_text.opening_description) {
      this.jobPosition.opening_description = this._utilsService.themeConfiguration.description_text.opening_description;
    }
    if (!!this._utilsService.themeConfiguration && !!this._utilsService.themeConfiguration.description_text && !!this._utilsService.themeConfiguration.description_text.closure_description) {
      this.jobPosition.closure_description = this._utilsService.themeConfiguration.description_text.closure_description;
    }
    this._utilsService.hideLoading();
  }

  public modalOpen(modalBasic) {
    let sizeOfModal: string = "sm";
    if (modalBasic._declarationTContainer.localNames[0] === "editDescriptionJobPositions") {
      sizeOfModal = "xl";
    }
    this.daysUnlockReport = 3;
    this.marginRequest = 1;
    this.marginCommissionProfit = 1;
    this.marginCommissionCost = 1;
    this.evidenceCost = 0;
    this._modalService.open(modalBasic, {
      size: sizeOfModal,
      centered: true,
    });
    //Resetto i valori a ogni apertura per riprendermi i dati salvati
    this.daysUnlockReport = this._utilsService.themeConfiguration.days_unlock_report;
    this.evidenceCost = this._utilsService.themeConfiguration.commission_standby_employee;
    if (!!this._utilsService.themeConfiguration && this._utilsService.themeConfiguration.description_text && !!this._utilsService.themeConfiguration.description_text.opening_description) {
      this.jobPosition.opening_description = this._utilsService.themeConfiguration.description_text.opening_description;
    }
    if (!!this._utilsService.themeConfiguration && !!this._utilsService.themeConfiguration.description_text && !!this._utilsService.themeConfiguration.description_text.closure_description) {
      this.jobPosition.closure_description = this._utilsService.themeConfiguration.description_text.closure_description;
    }
    this.retroActiveDate = this._utilsService.themeConfiguration.set_retroactive_date_commission;

    this._utilsService.themeConfiguration.working_days.map((item: number) => {
      this.weekSetup[item].isWorkDay = true;
    });
    this.marginRequest = this._utilsService.themeConfiguration.request_margin;
    this.marginCommissionProfit = this._utilsService.themeConfiguration.commission_percentage_profit;
    this.marginCommissionCost = this._utilsService.themeConfiguration.commission_percentage_cost;
  }

  //Funzione per salvare i giorni lavorativi o festivi
  saveWorkDay() {
    let data: any = [];

    this.weekSetup.map((item: any, index: number) => {
      if (item.isWorkDay) {
        data.push(index);
      }
    });
    if (!data || data.length < 1) {
      this._utilsService.showSWALError({ text: "SET_AT_LEAST_ONE_DAY" });
      return false;
    }
    this._utilsService.updateOption("working_days", data).then(() => {
      this._modalService.dismissAll();
    });
  }

  //Funzione per controllare che la variabile daysUnlockReport sia non superiore a 20 giorni lavorativi e minore a un giorno
  controlValue() {
    if (this.daysUnlockReport > 20) {
      this.daysUnlockReport = 20;
    }
    if (this.daysUnlockReport < 1) {
      this.daysUnlockReport = 1;
    }
  }

  /*Funzione per salvare il parametro della quantità
    di giorni lavorativi precedenti all'ultimo del mese per l'invio del rapportino*/
  saveDaysUnlockReport() {
    if (this.daysUnlockReport < 1 || this.daysUnlockReport > 20) {
      this._utilsService.showSWALError({ text: "SET_A_RIGHT_QUANTITY" });
      return false;
    }
    this._utilsService.updateOption("days_unlock_report", this.daysUnlockReport).then(() => {
      this._modalService.dismissAll();
    });
  }

  /*Funzione per salvare il margine sulle richieste*/
  saveMarginRequest() {
    if (this.marginRequest < 1) {
      this._utilsService.showSWALError({ text: "SET_MARGIN_UP_TO_ONE" });
      return false;
    }
    this._utilsService.updateOption("request_margin", this.marginRequest).then(() => {
      this._modalService.dismissAll();
    });
  }
  saveMarginCommissionProfit() {
    if (this.marginCommissionProfit < 1) {
      this._utilsService.showSWALError({ text: "SET_MARGIN_UP_TO_ONE" });
      return false;
    }
    this._utilsService.updateOption("commission_percentage_profit", this.marginCommissionProfit).then(() => {
      this._modalService.dismissAll();
    });
  }
  saveMarginCommissionCost() {
    if (this.marginCommissionCost < 1) {
      this._utilsService.showSWALError({ text: "SET_MARGIN_UP_TO_ONE" });
      return false;
    }
    this._utilsService.updateOption("commission_percentage_cost", this.marginCommissionCost).then(() => {
      this._modalService.dismissAll();
    });
  }
  setDescriptionJobPositions() {
    if (!this.jobPosition.opening_description || this.jobPosition.opening_description.length < 1 || !this.jobPosition.closure_description || this.jobPosition.closure_description.length < 1) {
      this._utilsService.showSWALError({ text: "OPEN_DESCRIPTION_AND_CLOSURE_DESCRIPTION_REQUIRED" });
      return false;
    }
    this._utilsService.updateOption("description_text", this.jobPosition).then(() => {
      this._modalService.dismissAll();
    });
  }

  sendEvidenceCommission() {
    if (!this.evidenceCost || this.evidenceCost < 1) {
      this._utilsService.showSWALError({ text: "SET_EVIDENCE_COST" });
      return false;
    }
    this._utilsService.updateOption("commission_standby_employee", this.evidenceCost).then(() => {
      this._modalService.dismissAll();
    });
  }

  setRetroActive() {
    this._utilsService.updateOption("set_retroactive_date_commission", this.retroActiveDate ? 1 : 0).then(() => {
      this._modalService.dismissAll();
    });
  }
}
